import React from 'react';
import { motion } from 'framer-motion';
import './FeedTransparency.css';

const FeedTransparency = () => {
  console.log('[FeedTransparency] Component rendered');
  
  return (
    <section className="feed-transparency">
      <div className="feed-transparency-container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="feed-transparency-content"
        >
          <h2 className="section-title">Transparency Promise</h2>
          <div className="gold-line"></div>
          <div className="feed-transparency-text">
            <p className="feed-transparency-intro">
              Feed-the-Cows is a voluntary seva initiative.
            </p>
            <ul className="feed-transparency-list">
              <li>No ownership is created</li>
              <li>No financial return is offered</li>
              <li>Contributions are not tax-deductible unless explicitly stated</li>
              <li>Funds are used exclusively for animal fodder</li>
            </ul>
            <p className="feed-transparency-closing">
              Faith deserves honesty and transparency.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FeedTransparency;


